module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAAQCAYAAAB5qQM2AAAACXBIWXMAAAsSAAALEgHS3X78AAAAn0lEQVRYhe3Y7Q2DMAxF0UfFANklGYRRGIEROkJH6CAephsEBSHUin4kJC60eXcAyz4/3XjvsSXnnAHQichl04AKO2VAnwFcawdMKRn7DroXkduu2/9YSdiEzisam9D5RWETukwfsQldrrfYhC7bS2xCl+8pNqF1WmETWq8HbELrtmATWr8Jm9DfqbHWmvmhFLAJrVgLIGAPf3vhUQIwAtFbSHMnkz9QAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/dnx-86.png
// module id = 1x7J
// module chunks = 1